export const projectId = '9bb05a529c02b3153952f53aa3d53014';

export const walletMetas = Object.freeze({
  metamask: {
    id: 'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    nativeLink: 'metamask://wc?uri=wc',
  }, // metamask: https://metamask.app.link/wc?uri=wc
  imToken: {
    id: '9d373b43ad4d2cf190fb1a774ec964a1addf406d6fd24af94ab7596e58c291b2',
    nativeLink: 'imtokenv2://wc?uri=wc',
  }, // imtoken: imtokenv2://wc?uri=wc
  zerion: {
    id: 'ecc4036f814562b41a5268adc86270fba1365471402006302e70169465b7ac18',
    nativeLink: 'zerion://wc?uri=wc',
  }, // Zerion wallet: https://wallet.zerion.io/wc?uri=
  // tokenPocket 自身支持问题，先隐藏
  // tokenPocket: {
  //   id: '20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66',
  //   nativeLink: 'tpoutside://wc?uri=wc',
  // }, // TokenPocket: tpoutside://wc?uri=wc
  trustWallet: {
    id: '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
    nativeLink: 'trust://wc?uri=wc',
  }, // Trust wallet: https://link.trustwallet.com/wc?uri=wc
  coinbase: {
    id: 'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa',
  },
});
